<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
      </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive">
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){

  },
  methods: {

  }
}
</script>

<style lang="less">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    color: #2c3e50;
  }
  *{
    -webkit-overflow-scrolling: touch;
    /*border: 1px solid red;*/
  }
  input{
    -webkit-appearance: none;
  }
  .van-button{
    display: block;
  }
  .van-nav-bar__left img {
      width: 25px;
      height: 25px;
  }
  /*文字超出省略*/
  .ellipsis {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: block;
  }

  .ellipsis-2 {
    display: -webkit-box;
    overflow: hidden;
    white-space: normal !important;
    text-overflow: ellipsis;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .container {
    /*width: 100vw;*/
    /*height: auto;*/
    /*position: absolute;*/
    /*top: 0;*/
    /*right: 0;*/
    /*bottom: 0;*/
    /*left: 0;*/
    /*overflow-y: scroll;*/
    padding-top: 50px;
    /*font-size: 14px;*/
    /*background-color: #ffffff;*/
  }
  .header{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    background: #ffffff;
  }
  .row{
    display: flex;
    flex-direction: row;
  }
  .flex-between{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .flex-center{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-itemsc: center;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue